/** student/skills — HOOKS. Static reference data → cached indefinitely. */
import { useQuery } from '@tanstack/react-query';
import { studentSkillsApi } from './api';
import { studentSkillsKeys } from './keys';

export function useSkills() {
  return useQuery({
    queryKey: studentSkillsKeys.all(),
    queryFn: () => studentSkillsApi.list(),
    staleTime: Infinity,
  });
}
